module.exports = __webpack_public_path__ + "static/acupun_1_lg-67e8fb98b1f879c46eac36dd244e8c51.webp";